import {
  DeleteConversationParams,
  RecentQAConversationsParams,
  RecentQAConversationsResponse,
  RenameConversationParams,
} from "./types";
import { RECENT_QA_TAGS } from "./constraints";
import { baseApi } from "@/api/baseApi";

export const recentQAApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getRecentQAConversations: builder.query<RecentQAConversationsResponse, RecentQAConversationsParams | void>({
      providesTags: [RECENT_QA_TAGS.RECENT_QA_TAG],
      query: (params = {}) => ({
        url: "/pf-mainweb/question-answer/conversations",
        method: "GET",
        params: {
          offset: params?.offset ?? 0,
          limit: params?.limit ?? 50,
          ...(params?.fse_entry_id && { fse_entry_id: params.fse_entry_id }),
        },
      }),
    }),
    renameConversation: builder.mutation<void, RenameConversationParams>({
      invalidatesTags: [RECENT_QA_TAGS.RECENT_QA_TAG],
      query: ({ conversation_id, name }) => ({
        url: `/pf-mainweb/question-answer/conversations/${conversation_id}/rename`,
        method: "PATCH",
        data: { name },
      }),
    }),
    deleteConversation: builder.mutation<void, DeleteConversationParams>({
      invalidatesTags: [RECENT_QA_TAGS.RECENT_QA_TAG],
      query: ({ conversation_id }) => ({
        url: `/pf-mainweb/question-answer/conversations/${conversation_id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useGetRecentQAConversationsQuery, useRenameConversationMutation, useDeleteConversationMutation } =
  recentQAApi;
